export default {
    reason: [],
    timeChanges: [],
    reasonChanges: [],
    divisionTimeChanges: null,
}
